/**
 * UI preferences localStorage helpers.
 * Used by UIPreferencesContext and by auth logout (clear on logout).
 */

import type { UIPreferences } from '@/services/api/shared/ui-preferences.service'

export const UI_PREFERENCES_STORAGE_KEY = 'vidhyantra_ui_preferences'
export const THEME_MODE_STORAGE_KEY = 'vidhyantra-theme-mode'

export function getStoredUIPreferences(): UIPreferences | null {
  try {
    const raw = localStorage.getItem(UI_PREFERENCES_STORAGE_KEY)
    const parsed = raw ? (JSON.parse(raw) as UIPreferences) : null
    const valid = parsed && (parsed.themeId != null || parsed.theme != null || parsed.mode != null)
    if (!valid) return null
    const prefs = parsed as UIPreferences
    const lastMode = localStorage.getItem(THEME_MODE_STORAGE_KEY) as UIPreferences['mode'] | null
    if (lastMode === 'light' || lastMode === 'dark' || lastMode === 'system') {
      return { ...prefs, mode: lastMode }
    }
    return prefs
  } catch {
    return null
  }
}

export function setStoredUIPreferences(prefs: UIPreferences): void {
  try {
    localStorage.setItem(UI_PREFERENCES_STORAGE_KEY, JSON.stringify(prefs))
  } catch {
    // ignore
  }
}

/** Call on logout so next user or re-login gets fresh prefs from backend. */
export function clearStoredUIPreferences(): void {
  try {
    localStorage.removeItem(UI_PREFERENCES_STORAGE_KEY)
  } catch {
    // ignore
  }
}
